module.exports = __webpack_public_path__ + "img/visu-fanage-flora@2x.d858b430.jpg";